import { unavailableOnWeb } from './unavailableOnWeb.web';
export const launchCamera = unavailableOnWeb('launchCamera');
export const launchImageLibrary = unavailableOnWeb('launchImageLibrary');
